/* global angular */

angular.module('AemCspsFunds')
  .controller('AemCspsFundsCtrl', ctrl)

ctrl.$inject = []
function ctrl () {}
